import React from "react"
import { Icon } from "@silversea-ssc/ui-components-react"
import { Trans } from "@lingui/macro"
import styles from "./Header.module.scss"

export type HeaderFAQButtonProps = {
    onClick?: () => void
}

const HeaderFAQButton: React.FC<HeaderFAQButtonProps> = ({ onClick }) => {
    return (
        <button data-content-piece="faq-link" onClick={onClick} className={styles.link}>
            <Icon name="circle-question" padding={false} size="1x" className={styles.linkIcon} ariaHidden={true} />
            <span className={styles.linkLabel}>
                <Trans>FAQ</Trans>
            </span>
        </button>
    )
}

export default HeaderFAQButton
